import { useCallback, useMemo } from "react";

export const noAffilieFormat = (noAffilie: string | undefined) => {
  if (!noAffilie) return "";

  if (noAffilie.includes(".") && noAffilie.includes("-")) {
    return noAffilie;
  }

  const noAffilieFormatte = ("00000000" + noAffilie).slice(-8);

  return (
    noAffilieFormatte.substring(0, 3) +
    "." +
    noAffilieFormatte.substring(3, 6) +
    "-" +
    noAffilieFormatte.substring(6, 8)
  );
};

export const noAffilieNormalize = (formattedValue: string | undefined) => {
  const normalized = formattedValue;
  if (!normalized) return "";
  return normalized.replace(/\.|-/g, "").replace(/^0+/, '');
};

const useNoAffilieFormatter = () => {
  const noAffilieFormatCallback =
    (noAffilie: string | undefined) => noAffilieFormat(noAffilie)

  const noAffilieNormalizeCallback = useCallback(
    (formattedValue: string | undefined) => noAffilieNormalize(formattedValue),
    [],
  );

  return useMemo(() => {
    return {
      noAffilieFormat: noAffilieFormatCallback,
      noAffilieNormalize: noAffilieNormalizeCallback,
    };
  }, [noAffilieFormatCallback, noAffilieNormalizeCallback]);
};

export default useNoAffilieFormatter;
